import { addModuleStyles } from '@glu/theming/glu-css-override';

const themeKey = 'legacyTooltips';

const defaultTheme = ({ legacy }) => (legacy ? undefined : {
  borderColor: '#dfdfdf'
});

const styles = ({ legacyTooltips }) => (legacyTooltips ? {
  root: {
    '& .popover[role="tooltip"]': {
      borderRadius: '3px',
      borderColor: legacyTooltips.borderColor,
      boxShadow: 'rgba(0, 0, 0, 0.2) 1px 1px 10px 0',

      '& .popover-title': {
        padding: '15px 22px'
      },
      '& .popover-content': {
        padding: '15px 22px'
      }
    }
  }
} : {});

addModuleStyles(styles, themeKey, defaultTheme);
